import React from 'react';
import Textarea from 'react-textarea-autosize';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';
import { MAX_LENGTH_VARIABLES } from '../../../const';
import PanelTextarea from '../CommonComponents/PanelTextarea';

export default function UserResponse(props) {
  const { disabled, placeHolder, onInput, value } = props;
  return (
    <div id="user-response-task" className={'global-task-review-container'}>
      <PanelTextarea
        label={I18n.t('panels.assignment.allowUserCommentHeader')}
        className={'comment-input user-response-task-textarea'}
        disabled={disabled}
        placeholder={placeHolder}
        onInput={onInput}
        maxCharacters={MAX_LENGTH_VARIABLES.COMMENT}
        value={value}
      />
    </div>
  );
}

UserResponse.propTypes = {
  placeHolder: PropTypes.string,
  value: PropTypes.string,
  onInput: PropTypes.func,
  disabled: PropTypes.bool
};
